function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "d",
  x: 0,
  y: 33,
  width: 46,
  height: 72,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "e",
  x: 101,
  y: 36,
  width: 84,
  height: 67,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 108"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Subtraction 3",
  d: "M109 81H5a5.006 5.006 0 01-5-5V5a5.006 5.006 0 015-5h104a5.006 5.006 0 015 5v71a5.006 5.006 0 01-5 5zM10 4a5.006 5.006 0 00-5 5v63a5.006 5.006 0 005 5h94a5.006 5.006 0 005-5V9a5.006 5.006 0 00-5-5z",
  transform: "translate(28)",
  fill: "#56d2f7"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#d)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 44",
  width: 28,
  height: 54,
  rx: 6,
  transform: "translate(9 39)",
  fill: "#1bd1f4"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#e)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 45",
  width: 66,
  height: 49,
  rx: 5,
  transform: "translate(110 42)",
  fill: "#1597ff"
})));

var SvgResponsive = function SvgResponsive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-responsive",
    viewBox: "0 0 185 105",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResponsive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/responsive.136e0bf0.svg";
export { ForwardRef as ReactComponent };